"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.create.success': '插槽数据创建成功',
    'slotData.create.error': '插槽数据创建失败',
};
